import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import routesConfig from '@config/routes.config.json';
import type { RouteConfig } from '@appTypes/route.types';
import { AppLayout } from '@components/layout/AppLayout';
import { SessionExpiredModal } from '@components/shared/SessionExpiredModal';
import { SessionExpiringSoonModal } from '@components/shared/SessionExpiringSoonModal';
import { SessionBootstrap } from './SessionBootstrap';
import { SessionSyncListener } from './SessionSyncListener';
import { SsoQueryCleanup } from './SsoQueryCleanup';
import { renderRoutes } from './RouteRenderer';

const typedRoutes = routesConfig.routes as RouteConfig[];

const publicRoutes = typedRoutes.filter((r) => !r.layout);
const layoutRoutes = typedRoutes.filter((r) => r.layout);

export function AppRouter() {
  return (
    <BrowserRouter>
      <SessionBootstrap />
      <SessionSyncListener />
      <SsoQueryCleanup />
      <SessionExpiredModal />
      <SessionExpiringSoonModal />
      <Routes>
        {renderRoutes(publicRoutes)}

        <Route element={<AppLayout />}>
          {renderRoutes(layoutRoutes)}
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
